
	import { Component, Vue, Prop } from 'vue-property-decorator';

	@Component({})
	export default class SideBarLevel1 extends Vue {
		@Prop({ required: true })
		protected state!: APS.IServerProps;

		protected get computedStyle(): Partial<CSSStyleDeclaration> {
			return {
				display: !this.isShowLeftMenu ? 'none' : '',
				minWidth: !this.isXSClientType ? '70px' : ''
			};
		}

		protected get isXSClientType(): boolean {
			return this.state.isXSClientType;
		}

		protected get isMDClientType(): boolean {
			return this.state.isMDClientType;
		}

		protected get isShowLeftMenu(): boolean {
			return this.state.isShowLeftMenu;
		}

		protected get isShowCopyrights(): boolean {
			return this.state.copyrights.show;
		}

		protected get sideBarClassIn(): boolean {
			return this.state.sideBarClassIn;
		}
	}
